import {MapPoint} from "../../webcomponents/serpmap/MapPoint";

export function renderSnippet(
    detail: MapPoint
) {
    return `<lamudi-snippet 
        name="${detail.title}" location="${detail.location}" description="${detail.description}" price="${detail.priceTag}" 
        bedrooms="${detail.bedrooms}" bathrooms="${detail.bathrooms}" area="${detail.area}" car-park="${detail.carSpaces}" 
        image="${detail.image}" number-of-images="${detail.numberOfImages}" url="${detail.url}" more-info="${detail.moreInfo}"></lamudi-snippet>`
}